<template>
  <div class="SoftwareDownloading">
    <!-- 课程介绍 -->
    <div class="box">
      <h5 class="isintroduced">课程介绍</h5>
      <p align="“left”" class="The-text" v-html="itemsa.kcjs"></p>
    </div>
  </div>
</template>
<script>
// import Bus from '@/utils/bus'
import { selitem } from "../../api/patient";
export default {
  data() {
    return {
      itemsa: {
        gm: "",
        id: "",
        itemtime: "",
        jg: "",
        jsjs: "",
        kcjs: "",
        ll: "",
        name: "",
        pf: "",
        plcyrs: "",
        plts: "",
        rjxz: {
          bhrjbb: [],
          id: "",
          rjjj: "",
          rjlb: "",
          rjmc: "",
          rjsm: "",
          rjsm1: "",
          rjsp: "",
          rjsp1: "",
          rjtb: "",
          rjtb1: "",
          softwaretime: "",
        },
        sc: "",
        scrq: "",
        softwareid: "",
        sort: "",
        sp: "",
        sp1: "",
        status: "",
        tsy: "",
        userid: "",
        xj: "",
      },
    };
  },
  created() {
    // this.$nextTick(() => {
    this.selitemid();
    // })
  },
  mounted() {
    // Bus.$emit('activeIndexss', '/SoftwareDownloading')
  },
  methods: {
    selitemid() {
      setTimeout(() => {
        const data = new FormData();
        data.append("id", this.$store.state.Jumpid);
        selitem(data).then((res) => {
          this.itemsa = res;
          // this.teps.pf = Number(this.teps.pf)
          // sessionStorage.setItem('itemss', JSON.stringify(res))
          // this.selrateis()
          // this.selcollectis(this.teps)
        });
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.SoftwareDownloading {
  width: 100%;
  .box {
    margin: 0 auto;
    width: 687px;
  }
}
.isintroduced {
  margin-top: 25px;
  margin-bottom: 19px;
  // width: 56px;
  text-align: left;
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.The-text {
  text-indent: 1rem;
  text-align: left;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
}

// 适配手机端
@media (max-width: 768px) {
  .SoftwareDownloading {
    width: 100%;
    .box {
      margin-left: 20px;
      width: 95vw;
    }
  }
}
</style>
